import { jsx } from "react/jsx-runtime";
import { isCallState, isOutputState } from "./types.js";
import { toolOutputToFeaturedProduct } from "./utils.js";
import { FeaturedProductWidget } from "../FeaturedProductWidget.js";
import { CollapsibleProductSummary } from "./CollapsibleProductSummary.js";
function FeaturedProductPart({
  part,
  allParts,
  productMetadataMap,
  pdpStacklineSku
}) {
  const suppressOutput = allParts.some((p) => p.type === "data-featured-product");
  if (isCallState(part.state)) {
    return /* @__PURE__ */ jsx("div", { className: "concierge-loading", children: "Loading product details..." });
  }
  if (suppressOutput) return null;
  const output = part.output;
  if (isOutputState(part.state) && output && !output.error) {
    const sku = output.sku || output.stacklineSku || "";
    const product = (productMetadataMap == null ? void 0 : productMetadataMap.get(sku)) || toolOutputToFeaturedProduct(output);
    const isPdpContext = !!(pdpStacklineSku && sku === pdpStacklineSku) || !!output.fromPdp;
    if (isPdpContext) {
      return /* @__PURE__ */ jsx(CollapsibleProductSummary, { product, defaultOpen: false, children: /* @__PURE__ */ jsx(FeaturedProductWidget, { product }) });
    }
    return /* @__PURE__ */ jsx(FeaturedProductWidget, { product });
  }
  return null;
}
export {
  FeaturedProductPart
};
//# sourceMappingURL=FeaturedProductPart.js.map
